import { t } from "i18next"
import { createPrivilegeObject } from "utils/privileges/privilegesMapper"

const TodoWorkflowTransformer = data => {
  if (!data?.workflowTODOs) return null

  let tableColumns = data?.workflowTODOs?.columns?.map(item => ({
    title: t(item?.title),
    dataIndex: item?.key,
    ...(item?.key === "request" && { width: 80 }),
  }))
  let stages = data?.workflowTODOs?.template?.stages?.map(item => ({
    ...item,
    privileges: createPrivilegeObject(item?.privileges || {}),
  }))

  let requests = data?.workflowTODOs?.requests?.map(item => ({
    ...item,
    privileges: createPrivilegeObject(item?.privileges || {}),
  }))

  let statisticObject = data?.workflowTODOs?.statistics?.reduce(
    (initialValue, item) => ({ ...initialValue, [item?.id]: item }),
    {}
  )

  let tabs = stages?.map(item => ({
    ...item,
    tab: item?.name,
    key: item?.key,
    statistic: statisticObject[item?.id]?.statistics,
  }))

  tableColumns?.push({ title: t("Actions"), dataIndex: "actions" })

  return { ...data, tableColumns, tabs, statisticObject, requests }
}

export default TodoWorkflowTransformer
